export class Productcategory {
    id: number;
    categoryName: string;
    store: string;
    storeId : number;
}

